__turbopack_context__.v({
  "clipboardStatus--expanded": "ot9L0W_clipboardStatus--expanded",
  "closeIcon": "ot9L0W_closeIcon",
  "container": "ot9L0W_container",
  "isOpenMobile": "ot9L0W_isOpenMobile",
});
